import { atom, useRecoilState } from 'recoil'

const sortState = atom({
  key: 'VoipCDRsSort',
  default: {
    by: 'start_date',
    direction: 'desc',
  },
})

type SortOutput = [
  {direction: string, by: string},
  (sort: string) => void
]
export const useSort = ():SortOutput => {
  const [{ direction, by }, setSort] = useRecoilState(sortState)
  return [
    { direction, by },
    (sort) => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    },
  ]
}